import React from "react";
import loaderImg from "../../assets/common-main-loader.gif";

export function MainLoader() {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/20 backdrop-blur-md">
      <img
        src={loaderImg}
        alt="Loading"
        className="h-64 w-auto select-none"
        draggable={false}
      />
    </div>
  );
}

